var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.917 2v2.835h-3.572l-.234.004c-4.043.124-7.295 3.476-7.295 7.58V30H7V12.42l.003-.273C7.148 6.527 11.731 2 17.345 2h3.573zm4.03.034v27.78h-2.712V2.033h2.712zm-11.664 15.24.094.006a.76.76 0 0 1 .661.755v.605l-.006.095a.758.758 0 0 1-.75.666h-1.304l-.094-.005a.76.76 0 0 1-.661-.755v-.605l.006-.095a.758.758 0 0 1 .748-.666h1.305z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaffle);
export default __webpack_public_path__ + "static/media/SAFFLE.29af6d589161ae2c7d44d8b7fff1d1aa.svg";
export { ForwardRef as ReactComponent };